module.exports = __webpack_public_path__ + "img/vertical_4_1_3.0378daea.png";